import LazyLoad from 'vanilla-lazyload';

export default class Lazy {

  static refresh() {
    const lazyLoadInstance = new LazyLoad({
      elements_selector: '.lazy'
    });

    if (lazyLoadInstance) {
      lazyLoadInstance.update();
    }
  }
}



// WEBPACK FOOTER //
// ./_common/scripts/lazy.js